module.exports = __webpack_public_path__ + "static/img/7areaA_01.4fbf4b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/7areaA_01.png
// module id = 1052
// module chunks = 1